import { DataStore } from '@ui-furniture/common/data-store/data-store';
import { DataStoreMementoCreator } from '@ui-furniture/common/data-store/data-store-memento-creator';

import { Action } from '../types/action';

export const createDataStoreTools = <TData extends object>(
  initialData: TData
) => {
  const dataStore = new DataStore<TData>(initialData);
  const { createMemento } = new DataStoreMementoCreator(dataStore);
  return {
    useData:
      <TReturn>(cb: (data: TData) => Action<TReturn>) =>
      () =>
        cb(dataStore.getData())(),
    updateData: (dataToUpdate: Partial<TData>) => () => {
      dataStore.updateData(dataToUpdate);
    },
    dataStore,
    createMemento,
  };
};
